<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="sign-manage-title search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span" style="margin-left:6px">管易订单</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div form-submit-page">
        <el-form :model="formInline" label-width="100px"  class="box-content-form">
          <el-form-item label="appKey:">
            <el-input v-model="formInline.appkey" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="secret:">
            <el-input v-model="formInline.secret" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="sessionKey:">
            <el-input v-model="formInline.sessionkey" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="url:">
            <el-input v-model="formInline.url" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="同步时间:" style="text-align: left;">
            <el-radio v-model="DayRadio" label="1">每天</el-radio>
            <el-time-picker
              v-model="formInline.tbtime"
              placeholder="选择时间"
              value-format="hh:mm:ss">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button class="reply-btn-type-goback" style="margin-right: 32px;float: left" @click='goBack'>返回</el-button>
            <el-button class="second-page-btn" style="float: left;" type="primary" @click='editGuanyi'>保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getGuanyi, editGuanyi } from '@/api/customer.js'
export default {
  name: 'easyOrder',
  data () {
    return {
      DayRadio: '1',
      formInline: {
        appkey: '',
        secret: '',
        sessionkey: '',
        url: '',
        tbtime: ''
      }
    }
  },
  computed: {
  },
  mounted () {
    this.getById()
  },
  methods: {
    // 获取详情
    getById() {
      getGuanyi().then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          let result = res.data.data
          this.formInline.appkey = result.appkey
          this.formInline.secret = result.secret
          this.formInline.sessionkey = result.sessionkey
          this.formInline.url = result.url
          this.formInline.tbtime = result.tbtime
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    editGuanyi() {
      let data = this.formInline
      editGuanyi(data).then((res) => {
        if (res.data.code === 0) {
          console.log(res)
          _g.toastMsg('success', '更新成功')
          this.goBack()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 890px;
  margin: 0 auto;
}
.box-content-form {
  margin: 61px auto;
  text-align: center;
  padding-left: 135px;
}
.box-content-form .el-form-item {
}
.avatar-uploader {
  border: 1px #d9d9d9 dashed;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  margin: 0 auto;
}
  .Reply{
    height: 100px;
  }
  .Reply li{
    width: 100px;
    height: 100px;
    margin-right: 20px;
    border: 1px solid #c0bfbf;
    border-radius: 5px;
    float: left;
    list-style: none;
    cursor: pointer;
    margin-bottom: 20px;
  }
  .Reply li i{
    font-size: 40px;
    margin: 20px 0 8px 0;
  }
  .Reply li span{
    display: block;
    font-size: 14px;
  }
  .Reply li:hover{
    color: #FF9B00;
    border: 1px solid #FF9B00
  }
  .replyMarketing{
    position: relative;
    top: -20px;
    height: 292px;
    text-align: left;
    padding-left: 20px;
  }
  .page{
    position: absolute;
    bottom: -44px;
    right: 0;
  }
</style>
